import React, { useEffect, useState } from "react";
import { Table, Checkbox, Button } from "antd";
import svg36 from "../../../assets/svg/svg36.svg";
import svg37 from "../../../assets/svg/svg37.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";
import CardLoading from "../../../components/CardLoading";

// const data = [
//   {
//     key: "1",
//     type: "Dashboard",
//     children: [
//       { key: "1-1", type: "Farmers" },
//       { key: "1-2", type: "MISPS" },
//     ],
//   },
//   {
//     key: "2",
//     type: "Schemes",
//     children: [],
//   },
//   {
//     key: "3",
//     type: "FLID",
//     children: [],
//   },
// ];

const PermissionTable = ({ type, tabKey }) => {
  const dispatch = useDispatch();
  const url = "prof/menu_profiles";
  const { loading, data, count, activeObjProfile } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    activeObjProfile: state.obj.activeObj["profile"],
  }));
   const {user} =  useSelector((state)=>state.auth) 

  const { refetchKey } = useSelector((state) => state.global);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [permissions, setPermissions] = useState({});

  const toggleExpand = (key) => {
    setExpandedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const handleSave = async (perId, perms) => {
    const perProfId = activeObjProfile?.profId || null;
    const payload = {
      url: "prof/permission",
      perDymId: perId,
      perProfId,
      read: perms?.read || false,
      write: perms?.write || false,
      delete: perms?.delete || false,
    };

    const res = await dispatch(save(payload));

    if (res?.payload?.success) {
      // await toast.success(res?.payload?.message);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleParentChange = (parentKey, children) => {
    const allChecked = children.every(
      (child) =>
        permissions[child?.dymId]?.checked &&
        permissions[child?.dymId]?.read &&
        permissions[child?.dymId]?.write &&
        permissions[child?.dymId]?.delete
    );

    const updatedPermissions = { ...permissions };

    children.forEach((child) => {
      const newPerms = allChecked
        ? { checked: false, read: false, write: false, delete: false }
        : { checked: true, read: true, write: true, delete: true };

      updatedPermissions[child?.dymId] = newPerms;
      handleSave(child?.dymId, newPerms);
    });

    setPermissions(updatedPermissions);
  };

  const handleRowCheckbox = (key) => {
    const isChecked = permissions[key]?.checked;
    const updated = {
      checked: !isChecked,
      read: !isChecked,
      write: !isChecked,
      delete: !isChecked,
    };
    setPermissions((prev) => ({
      ...prev,
      [key]: updated,
    }));
    handleSave(key, updated);
  };

  const handlePermissionChange = (key, permissionType) => {
    const updated = {
      ...permissions[key],
      [permissionType]: !permissions[key]?.[permissionType],
    };

    setPermissions((prev) => ({
      ...prev,
      [key]: updated,
    }));

    handleSave(key, updated);
  };

  const columns = [
    {
      title: "Type",
      dataIndex: "dymLabel",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {record?.children && record?.children?.length > 0 ? (
            <Checkbox
              checked={record?.children?.every(
                (child) => permissions[child?.dymId]?.checked
              )}
              indeterminate={
                record.children.some(
                  (child) => permissions[child?.dymId]?.checked
                ) &&
                !record.children.every(
                  (child) => permissions[child?.dymId]?.checked
                )
              }
              onChange={() =>
                handleParentChange(record?.dymId, record?.children)
              }
            />
          ) : (
            <Checkbox
              checked={permissions[record?.dymId]?.checked || false}
              onChange={() => handleRowCheckbox(record.dymId)}
            />
          )}
          <span style={{ marginLeft: 8 }}>{record?.dymLabel}</span>
          {record?.children && record?.children?.length > 0 && (
            <Button
              type="text"
              size="small"
              icon={
                expandedKeys?.includes(record?.dymId) ? (
                  <img src={svg37} alt="expand" />
                ) : (
                  <img src={svg36} alt="collapse" />
                )
              }
              onClick={() => toggleExpand(record?.dymId)}
            />
          )}
        </div>
      ),
    },
    {
      title: "Read",
      key: "read",
      render: (_, record) =>
        !record.children || record.children.length === 0 ? (
          <Checkbox
            checked={permissions[record?.dymId]?.read || false}
            onChange={() => handlePermissionChange(record?.dymId, "read")}
          />
        ) : null,
    },
    {
      title: "Write",
      key: "write",
      render: (_, record) =>
        !record?.children || record?.children.length === 0 ? (
          <Checkbox
            checked={permissions[record?.dymId]?.write || false}
            onChange={() => handlePermissionChange(record?.dymId, "write")}
          />
        ) : null,
    },
    {
      title: "Delete",
      key: "delete",
      render: (_, record) =>
        !record.children || record?.children?.length === 0 ? (
          <Checkbox
            checked={permissions[record?.dymId]?.delete || false}
            onChange={() => handlePermissionChange(record?.dymId, "delete")}
          />
        ) : null,
    },
  ]; 
  async function fetchTableData() {
    console.log("beeeing............")
    await dispatch(
      fetchData({
        url: url,
        dymType: type ?? user?.usrType,
        perProfId: activeObjProfile?.profId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    if (refetchKey === tabKey) {
      fetchTableData();
    }
  }, [refetchKey, tabKey]);

  useEffect(() => {
    fetchTableData();
  }, []);

  useEffect(() => {
    if (!data || data?.length === 0) return;

    const buildPermissions = (items) => {
      const result = {};

      const traverse = (arr) => {
        arr?.forEach((item) => {
          result[item.dymId] = {
            checked: item?.read || item?.write || item?.delete,
            read: item?.read || false,
            write: item?.write || false,
            delete: item?.delete || false,
          };
          if (item?.children && item?.children?.length > 0) {
            traverse(item?.children);
          }
        });
      };

      traverse(items);
      return result;
    };

    const perms = buildPermissions(data);
    setPermissions(perms);
  }, [data]);

  if (loading) return <CardLoading />;
  return (
    <Table
      className="permission-table"
      columns={columns}
      dataSource={data}
      pagination={false}
      rowKey="dymId"
      expandable={{
        expandedRowKeys: expandedKeys,
        onExpand: (expanded, record) => toggleExpand(record?.dymId),
      }}
    />
  );
};

export default PermissionTable;
